import React, { useEffect, useState } from 'react'
import shape from '../../assets/images/shopping-arrow.png'
import { Link, useNavigate } from 'react-router-dom';
import CartTotal from '../Shopingcartpage/CartTotal';
import { api } from '../../Constant';
import axios from 'axios';
import BillingEditform from './BillingEditform';



const BillingEdit = () => {
    const [cartUpdated, setCartUpdated] = useState([]);
    const navigation = useNavigate('');
    const [userid, setUserid] = useState('');


      const getUserIdentifier = () => {
      const userId = localStorage.getItem("userId");
      const guestId = localStorage.getItem("guest_id");
    
      if (userId && userId !== guestId) {
        return { user_id: userId };
      } else {
        return { guest_id: guestId };
      }
    };
    
    
     useEffect(() => {
      const userId = localStorage.getItem("userId");
      setUserid(userId);
    
      if (userId && userId !== "Guest") {
     
        axios.post(api + "cart_list", getUserIdentifier())
          .then(response => {
            if (response.data.success === "true") {
              const products = response.data.product || [];
              setCartUpdated(products);
            } else {
              console.log("No products found in cart");
            }
          })
          .catch(error => {
            console.log("Error:", error);
          });
      } else {
        // Guest cart from localStorage
        const guestCart = JSON.parse(localStorage.getItem("guestCart")) || [];
        setCartUpdated(guestCart);
      }
    }, []);

    return (

        <div className='billing-form pt-40 pb-40'>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-8'>
                        <div className='row'>
                            <div className='col-lg-12 shopping-tit-container'>
                                <h3>SHOPPING CART</h3>
                                <img src={shape} />
                                <h1>BILLING ADDRESS</h1>
                                <img src={shape} />
                                <h3>PAYMENT DETAIL</h3>
                            </div>
                        </div>
                        <BillingEditform nav={'/Billing-Address'} />
                    </div>
                    <div className='col-lg-4 shoping-cartscroll'>
                        <CartTotal CartTotal="PROCEED TO PAY" cartUpdated={cartUpdated} />
                    </div>
                </div>
            </div>
        </div>

    )
}

export default BillingEdit